/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

export enum ViewState{
    initial,
    loading,
    success,
    failed
}